export const identifiers = {
  authData: 'authData',
  authorization_code: 'authorization_code',
  tokenData: 'tokenData',
  userData: 'userData',
  participateData: 'participateData',
  amount: 'amount',
  acceptlanguage: 'acceptlanguage',
};